import { useSelector } from "react-redux"

const useCookiesConsent = () => useSelector(state => state.gdpr.hasAllowedCookies)

export default useCookiesConsent
